<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YDOPnR/tc-custom/9781609456887.jpg?1726519260518" alt="This image is the cover for the book April Dead, The Harry McCoy Thrillers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">April Dead, The Harry McCoy Thrillers
      </h1>
      <p class="bookDescription body article font2">
        <b>From an Edgar Award finalist: A cop tracks a shadowy, fanatical group in a “tightly plotted and fast-moving” noir mystery set in 1970s Glasgow (<i>Publishers Weekly</i>, starred review).</b><br/><br/>When an American sailor from the Holy Loch Base goes missing, Harry McCoy is determined to find him. But as he investigates, a wave of bombings hits Glasgow. Soon McCoy realizes that the sailor may be part of a shadowy organization led by a dangerous fanatic, and committed to a very different kind of Scotland. A Scotland its members are prepared to kill for.<br/><br/>Meanwhile Cooper, McCoy’s longtime criminal friend, is released from jail and is convinced he has a traitor in his midst. As allies become enemies, Cooper has to fight to maintain his position as crime kingpin. He needs something done, something illegal—and his old friend McCoy is the only one who can do it.<br/><br/>As word begins to circulate on the streets that another, bigger explosion is being planned for Glasgow, McCoy battles corruption in his ranks in an attempt to save the city . . . <br/><br/>“Lean, muscular prose . . . A full-bodied immersion into Glasgow’s gritty past.” —<i>Kirkus Reviews</i><br/><br/>“A series that no crime fan should miss.” —<i>Scotsman</i><br/><br/>“One of the best police thrillers of the last few years.” —<i>Morning Star</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Parks
      </h2>
      
      <p class="authorDescription body article"><B>Alan Parks</B>&#160;worked in the music industry for over twenty years before becoming a full-time writer. His debut novel <I>Bloody January</I>&#160;was one of the top crime debuts of 2018 and was shortlisted for the prestigious international crime prize the Grand Prix de Litt&eacute;rature Polici&egrave;re. <I>February&rsquo;s Son</I>, book two in the series, was a finalist for a Mystery Writers of America Edgar Award. Parks lives and works in Glasgow.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Europa Editions
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13372edc